/**
 * Wrap a media URL in Next.js's image optimizer so it is served as AVIF/WebP at a
 * sensible width — for places where `<Image>` can't be used directly (CSS
 * `background-image`, `<video poster>`). Mirrors what `next/image` does under the hood.
 *
 * `width` must be one of the configured device/image sizes and `quality` one of
 * `images.qualities` in next.config.ts (80 | 100).
 */
export function getOptimizedImageUrl(
  src: string | null | undefined,
  width = 1080,
  quality = 80,
): string | undefined {
  if (!src) return undefined
  const s = src.trim()
  if (!s) return undefined
  // Already optimized, inline, or a blob — leave untouched.
  if (s.startsWith('/_next/image') || s.startsWith('data:') || s.startsWith('blob:')) return s
  return `/_next/image?url=${encodeURIComponent(s)}&w=${width}&q=${quality}`
}
